module.exports = __webpack_public_path__ + "img/gb95-85.prt.323d847a.jpg";